import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import BusinessIcon from '@material-ui/icons/Business';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
import InfoArea from '../InfoArea/InfoArea';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import styles from 'assets/jss/material-kit-react/views/landingPageSections/productStyle';

const useStyles = makeStyles(styles);

export default function ThreeIcons() {
  const classes = useStyles();
  return (
    <Container className={classes.section} component='section'>
      <GridContainer justify='center'>
        <GridItem xs={12} sm={12} md={8}>
          <Typography variant='h2' gutterBottom>
            About Us
          </Typography>
          <Typography variant='body1' gutterBottom>
            We are a professional domestic cleaning company service covering
            Blackwood and surrounding areas. We also offer professional
            commercial cleaning services. Please contact us to get a quote
            today.
          </Typography>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
          <InfoArea
            title='Domestic Cleaning'
            description='Weekly cleans worked around your needs. We will keep your home feeling fresh, comfortable and effortless.'
            icon={HomeIcon}
            iconColor='info'
            vertical
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <InfoArea
            title='Commercial Cleaning'
            description='We are available for contracting for office/business cleaning. Contact our team to get started.'
            icon={BusinessIcon}
            iconColor='success'
            vertical
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <InfoArea
            title='Bespoke Cleaning'
            description='No job is too big or small. We also offer end of tenancy cleaning, one-off cleaning and more!'
            icon={NewReleasesIcon}
            iconColor='danger'
            vertical
          />
        </GridItem>
      </GridContainer>
    </Container>
  );
}
